<div class="form-section">
	<div class="form-group">
		@if (!hideName) {
			<mat-form-field appearance="outline" class="full-width">
				<mat-label translate="activity-editor-new_activity-name-input-label"></mat-label>
				<input
					matInput
					type="text"
					[formControl]="activityFormService.getControl('name')"
					data-cy="activity-editor-name-input"
					maxlength="255">
				@if (activityFormService.getControl('name').invalid && activityFormService.getControl('name').touched) {
					<mat-error>
						@if (activityFormService.getControl('name').errors?.['required']) {
							<span translate="activity-editor-new_form-validation-error-name-required"></span>
						} @else if (activityFormService.getControl('name').errors?.['maxlength']) {
							<span translate="activity-editor-new_form-validation-error-name-max-length"></span>
						}
					</mat-error>
				}
			</mat-form-field>
		}
	</div>

	<activity-type-dropdown
		[activity]="activity"
		[template]="selectedTemplate"
		(onTemplateSelect)="handleTemplateSelect($event)">
	</activity-type-dropdown>

	<source-media-setting
		[show]="shouldShowSourceMediaSetting()"
		[showSourceTypeDropdown]="shouldShowSourceTypeDropdown()"
		[showSourceMediaButton]="shouldShowSourceMediaButton()"
		[activity]="activity">
	</source-media-setting>

	@if (!hideDates) {
		<div class="form-group date-picker-group">
			<ngx-datetime-picker
				[property]="'available_at'">
			</ngx-datetime-picker>
			<ngx-datetime-picker
				[property]="'due_at'">
			</ngx-datetime-picker>
		</div>
	}

	@if (activity.isViewable('use_score')) {
		<activity-grading [activity]="activity"></activity-grading>
	}

	<activity-edit-ai-markers-section
		[activity]="activity">
	</activity-edit-ai-markers-section>

	<ngx-activity-edit-marker-section
		[activity]="activity">
	</ngx-activity-edit-marker-section>

	<activity-attachments
		[activity]="activity">
	</activity-attachments>

	@if (shouldShowVideoShareSetting()) {
		<div class="form-group">
			<mat-checkbox
				color="primary"
				[formControl]="activityFormService.getControl('is_video_share_enabled')"
				data-cy="activity-editor-enable-guest-review">
				<span translate="activity-editor-new_video-share-label"></span>
			</mat-checkbox>
			<button
				[goCdkPopover]="'activity-editor-new_video-share-help' | translate"
				class="ficon-app-help-circle-outline icon-btn">
			</button>
		</div>
	}
</div>
